
export const Routes = {
    //Presentation: { path: "/" },
    Dashboard: { path: "/" }, // add it here
    Phonics: { path: "/phonics" }, // add it here
};